import { render } from "./MatchTable.vue?vue&type=template&id=49be6579&scoped=true"
import script from "./MatchTable.vue?vue&type=script&lang=js"
export * from "./MatchTable.vue?vue&type=script&lang=js"

import "./MatchTable.vue?vue&type=style&index=0&id=49be6579&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49be6579"]])

export default __exports__